import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@ibk/shared-auth';
import Login from '../Login/Login';
import BpoAuthLayout from './BpoAuthLayout';
import { setBpoLoginDestination } from './bpoSession';
export default function BpoLogin() {
    const { isAuthenticated } = useAuth();
    useEffect(() => {
        setBpoLoginDestination();
    }, []);
    if (isAuthenticated)
        return _jsx(Navigate, { to: '/bpo/clientes', replace: true });
    return (_jsx(BpoAuthLayout, { showBack: true, children: _jsx(Login, { bpo: true }) }));
}
